var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isDesktop && !_vm.$store.getters.coverHidden)?_c('Cover'):[_c('Menu'),_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view',{staticClass:"view"})],1),_c('FooterFixed',{staticClass:"footer"})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }